import { htmlComponent } from '../../components/htmlComponent';
import { TextLink } from '../../components/Link';
import { List } from '../../components/List';
import { Paragraph } from '../../components/Paragraph';
import { EmphasizedText, ImportantText } from '../../components/Text';
import { Title } from '../../components/Title';
import { ListItemWithIcon, TextBreak } from './specialTags';
import { RteImage } from "../../components/RteImage";

export const tagToComponent = {
  p: Paragraph,
  a: TextLink,
  em: EmphasizedText,
  strong: ImportantText,
  ul: List,
  li: ListItemWithIcon,
  h1: Title.ContentTitle,
  h2: Title.ContentTitle,
  h3: Title.ContentTitle,
  h4: Title.ContentTitle,
  h5: Title.ContentTitle,
  h6: Title.ContentTitle,
  br: TextBreak,
  // TODO: create special Component to place iframe-content in grid
  iframe: htmlComponent('iframe'),
  table: htmlComponent('table'),
  thead: htmlComponent('thead'),
  tbody: htmlComponent('tbody'),
  th: htmlComponent('th'),
  td: htmlComponent('td'),
  tr: htmlComponent('tr'),
  span: htmlComponent('span'),
  div: htmlComponent('div'),
  img: RteImage,
};
